import React from "react";

import AvaliacaoAcaoConsumerContent from "./component/AvaliacaoAcaoConsumerContent";
import { AvaliacaoAcaoProvider } from "./component/AvaliacaoAcaoContext";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
const AvaliacaoAcaoRagExecucao = (props) => {
  return (
    <CardSeplagScrol>
      <AvaliacaoAcaoProvider props={props}>
        <AvaliacaoAcaoConsumerContent props={props} />
      </AvaliacaoAcaoProvider>
    </CardSeplagScrol>
  );
};

export default AvaliacaoAcaoRagExecucao;
